import APIToken from '@console/components/project/APIToken';
import type { AppState } from '@console/reducers';
import { getApiConfidentialInformation } from '@console/selectors/projectDetail/confidentialInformation';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  apiConfidentialInformation: getApiConfidentialInformation(state)
});

const mapDispatchToProps = () => ({});

export type APITokenPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type APITokenPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(APIToken);
